"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComparisonFeature_1 = require("./ComparisonFeature");
exports.default = ComparisonFeature_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonFeature/index.js
// module id = 1314
// module chunks = 8